export const PERMISSIONVIEWS: Object = {
  permissions: 'permview',
  'region-by-region': 'regionviewbyregion',
  'region-by-vehicle': 'regionviewbyvehicle',
};
